import { render, staticRenderFns } from "./PreviousPolicyODCoverDetails.vue?vue&type=template&id=c4fa3628&scoped=true"
import script from "./PreviousPolicyODCoverDetails.vue?vue&type=script&lang=js"
export * from "./PreviousPolicyODCoverDetails.vue?vue&type=script&lang=js"
import style0 from "./PreviousPolicyODCoverDetails.vue?vue&type=style&index=0&id=c4fa3628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa3628",
  null
  
)

export default component.exports